module.exports = __webpack_public_path__ + "img/floor_f15_02.65b83c9d.png";